import type { LegendProps } from "recharts";
import React from "react";

import { twMerge } from "tailwind-merge";

const CustomLegend = (props: LegendProps) => {
  return (
    <ul className="recharts-default-legend flex gap-[8px]">
      {props.payload?.map((payload, i) => {
        const { value, color, inactive } = payload;

        return (
          <li
            key={value}
            className={twMerge(`recharts-legend-item legend-item-${i} flex cursor-pointer items-center`, inactive && "opacity-[0.44]")}
            onClick={e => props.onClick?.(payload, i, e)}
          >
            <span className="mr-[8px] inline-flex h-[12px] w-[12px]" style={{ backgroundColor: color }} />
            <span className="font-mono text-[12px] uppercase tracking-[.5px]" style={{ color }}>
              {value}
            </span>
          </li>
        );
      })}
    </ul>
  );
};

export default CustomLegend;
